import React, { useRef, useEffect } from 'react';

const OutsideClickHandler = ({
  onClick,
  children,
  element = 'div',
  ...rest
}) => {
  const ref = useRef(null);
  const CustomTag = element;

  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      onClick(event);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <CustomTag ref={ref} {...rest}>
      {children}
    </CustomTag>
  );
};

export default OutsideClickHandler;
